import { ModalActionTypes, PromptConfig } from '@acorns/web-components'

const ROUNDUPS_INVESTED_TEXT =
  'Moving forward, Acorns will invest your Round-Ups automatically for you when they reach $5. You can track your progress on the Round-Ups screen.'

const RoundupsInvestedPrompt: PromptConfig = {
  image: null,
  title: 'Your Round-Ups are invested!',
  message: ROUNDUPS_INVESTED_TEXT,
  actions: [
    {
      type: ModalActionTypes.primary,
      label: 'Got it!',
    },
  ],
}

export { RoundupsInvestedPrompt }
